import React, {useEffect, useMemo, useState} from "react";
import "./style.scss";
import {useTable, usePagination} from "react-table";

import CaretLeftIcon from "../../../assets/icons/caret-left.svg";
import CaretRightIcon from "../../../assets/icons/caret-right.svg";
import HamburgerIcon from "../../../assets/icons/hamburger.svg";
import HamburgerBlueIcon from "../../../assets/icons/hamburger-blue.svg";
import CaretDownWhiteIcon from "../../../assets/icons/caret-down-white.svg";
import DollarCircleIcon from "../../../assets/icons/dollar-circle.svg";
import DollarBoxIcon from "../../../assets/icons/dollar-box.svg";
import DiscountCircleIcon from "../../../assets/icons/discount-circle.svg";
import TickBlueIcon from "../../../assets/icons/tick-blue.svg";
import CaretDownGrayIcon from "../../../assets/icons/caret-down-gray.svg";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import ChartRepGain from "../../../assets/images/chart-rep-gain.png";
import ChartRepLoss from "../../../assets/images/chart-rep-loss.png";
import {useSelector} from "react-redux";
import moment from "moment";
import ErrorModal from "../../../reusableComponents/ErrorModal";
import {useNavigate} from "react-router-dom";
import {Add, Delete, Edit} from "@mui/icons-material";
import {Pagination} from "@mui/material";
import {convertTimestamp, formatUSD} from "../../../utils/helpers/string";
import ReactTable from "../../ReactTable/ReactTable";
import {isValid} from "date-fns";
import {formToJSON} from "axios";

function TradingActivity({Ametric, isTradelocker}) {
  const [isDropdown, setDropdown] = useState(false);
  const accountsData = useSelector((state) => state.account.accountMetrics);
  const [Ametrics, setAmetrics] = useState(accountsData?.data?.account_metrics?.deals || []);

  useEffect(() => {
    setAmetrics(accountsData?.data?.account_metrics?.deals || []);
  }, [accountsData]);
  const {selectedBrand} = useSelector((state) => state.brand);
  const columnsMT5Matchtrade = React.useMemo(
    () => [
      {
        Header: () => <div className="column_header">Action </div>,
        accessor: "action",
        Cell: ({value}) => (
          <div className="column_one_wrapper">
            <div className={value === "Buy" ? "profit" : "loss"}>{value}</div>
          </div>
        ),
      },
      {
        Header: () => <div className="column_header">Position</div>,
        accessor: "position",
      },
      {
        Header: "Symbol",
        accessor: "symbol",
      },
      {
        Header: () => <div className="column_header">Open Date</div>,
        accessor: "dateOpen",
        Cell: ({value}) => <div>{value ? (moment(value)?.isValid() ? moment(value)?.format("DD-MM-YYYY") : "-") : "-"}</div>,
      },
      {
        Header: () => <div className="column_header">Close Date</div>,
        accessor: "dateClose",
        Cell: ({value}) => <div>{value ? (moment(value)?.isValid() ? moment(value)?.format("DD-MM-YYYY") : "-") : "-"}</div>,
      },
      {
        Header: () => <div className="column_header">Profit</div>,
        accessor: "profitSum",
        Cell: ({value}) => <div className={value < 0 ? "loss" : "profit"}>{formatUSD(value || 0)}</div>,
      },
      {
        Header: () => <div className="column_header">Commission</div>,
        accessor: "commissionSum",
        Cell: ({value}) => <div className={value < 0 ? "loss" : "profit"}>{value}</div>,
      },
      {
        Header: () => <div className="column_header">Swap</div>,
        accessor: "swapSum",
      },
      {
        Header: () => <div className="Volume">Volume</div>,
        accessor: "volume",
        Cell: ({row}) => <div>{Math.abs(row.original.volumeSumBuy || row.original.volumeSumSell || 0) || "NA"}</div>,
      },
      {
        Header: () => (
          <Tooltip
            title="Average price when bought"
            placement="top"
            arrow
          >
            <span>Avg Price Buy</span>
          </Tooltip>
        ),
        accessor: "priceAvgBuy",
        Cell: ({value}) => <div>{formatUSD(value || 0)}</div>,
      },
      {
        Header: () => (
          <Tooltip
            title="Average price when sold"
            placement="top"
            arrow
          >
            <span>Avg Price Sell</span>
          </Tooltip>
        ),
        accessor: "priceAvgSell",
        Cell: ({value}) => <div>{formatUSD(value || 0)}</div>,
      },
      {
        Header: "Stop Loss",
        accessor: "stopLoss",
        Cell: ({value}) => <div>{formatUSD(value || 0)}</div>,
      },
      {
        Header: "Take Profit",
        accessor: "takeProfit",
        Cell: ({value}) => <div>{formatUSD(value || 0)}</div>,
      },
    ],
    [],
  );
  const columnsTradelocker = React.useMemo(
    () => [
      {
        Header: "Instrument",
        accessor: "instrument",
      },
      // {
      //   Header: "Open Time (Milliseconds)",
      //   accessor: "openMilliseconds",
      // },
      {
        Header: "Open Date/Time",
        accessor: "openDateTime",
        Cell: ({value}) => <div>{moment(value)?.isValid() ? moment(value)?.format("DD-MM-YY") : "-"}</div>,
      },
      {
        Header: "Order Type",
        accessor: "orderType",
      },
      {
        Header: "Position Side",
        accessor: "positionSide",
        Cell: ({value}) => <div className={value === "Buy" ? "profit" : "loss"}>{value}</div>,
      },
      {
        Header: "Close Amount",
        accessor: "closeAmount",
        Cell: ({value}) => <div className={value > 0 ? "profit" : "loss"}>{formatUSD(value || 0)}</div>,
      },
      {
        Header: "Average Open Price",
        accessor: "averageOpenPrice",
        Cell: ({value}) => <div>{formatUSD(value || 0)}</div>,
      },
      {
        Header: "Close Price",
        accessor: "closePrice",
        Cell: ({value}) => <div>{formatUSD(value || 0)}</div>,
      },
      {
        Header: "Close Date/Time",
        accessor: "closeDateTime",
        Cell: ({value}) => <div>{moment(value)?.isValid() ? moment(value)?.format("DD-MM-YY") : "-"}</div>,
      },
      {
        Header: "Open Amount",
        accessor: "openAmount",
        Cell: ({value}) => <div>{formatUSD(value || 0)}</div>,
      },
      {
        Header: "Commission",
        accessor: "commission",
        Cell: ({value}) => <div className={value > 0 ? "profit" : "loss"}>{value}</div>,
      },
      {
        Header: "Swap",
        accessor: "swap",
      },
      {
        Header: "Profit",
        accessor: "profit",
        Cell: ({value}) => <div className={value > 0 ? "profit" : "loss"}>{formatUSD(value || 0)}</div>,
      },
      {
        Header: "Net Profit",
        accessor: "netProfit",
        Cell: ({value}) => <div className={value > 0 ? "profit" : "loss"}>{formatUSD(value || 0)}</div>,
      },
    ],
    [],
  );
  const columns = isTradelocker === "tradelocker" ? columnsTradelocker : columnsMT5Matchtrade;
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div className="tradingactivity-container">
      <div className="tradingactivity-subcontainer">
        {isDropdown ? (
          <div className="tradingactivity-dropdown">
            <h4>SL/TP Format</h4>
            <button>
              <p>Profit</p>
              <img
                src={CaretDownWhiteIcon}
                alt=""
              />
            </button>
            <ul>
              <li>
                <div>
                  <img
                    src={DollarCircleIcon}
                    alt=""
                  />
                  <p>Buy</p>
                </div>
                <img
                  src={TickBlueIcon}
                  alt=""
                />
              </li>
              <li>
                <div>
                  <img
                    src={DollarBoxIcon}
                    alt=""
                  />
                  <p>Sell</p>
                </div>
                <img
                  src={TickBlueIcon}
                  alt=""
                />
              </li>
              <li>
                <div>
                  <img
                    src={DollarBoxIcon}
                    alt=""
                  />
                  <p>Withdrawal</p>
                </div>
                <img
                  src={TickBlueIcon}
                  alt=""
                />
              </li>
              <li>
                <div>
                  <img
                    src={DollarCircleIcon}
                    alt=""
                  />
                  <p>Deposite</p>
                </div>
                <img
                  src={TickBlueIcon}
                  alt=""
                />
              </li>
              <li>
                <div>
                  <img
                    src={DiscountCircleIcon}
                    alt=""
                  />
                  <p>Interest</p>
                </div>
                <img
                  src={TickBlueIcon}
                  alt=""
                />
              </li>
            </ul>
          </div>
        ) : (
          <></>
        )}
        <div className="tradingactivity-container_table">
          <ReactTable
            columns={columns}
            data={Ametrics}
            isTradelocker={accountsData?.data?.trading_platform}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
}

export default TradingActivity;

// function Table() {
//   const data = Ametric;
//   const navigate = useNavigate();
//   const handleEdit = (row) => {
//     navigate("/trademate/create-trade", {state: {data: row.row.original}});
//   };
//   const [paramID, setParamID] = useState(null);
//   const [confirmationModal, setConfirmationModal] = useState(false);
//   const handleDelete = (row) => {
//     setConfirmationModal(true);
//     setParamID(row?.row?.original?.id);
//   };

//   const handleConfirmDelete = async () => {
//     try {
//       //
//     } catch (error) {}
//   };

//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     page,
//     previousPage,
//     nextPage,
//     canPreviousPage,
//     canNextPage,
//     gotoPage,
//     pageCount,
//     pageOptions,
//     state: {pageIndex, pageSize},
//     rows,
//     prepareRow,
//   } = useTable({columns, data}, usePagination);

//   const [currentPage, setCurrentPage] = useState(1);
//   const pageButtons = [];

//   const [gotoPageInput, setGotoPageInput] = useState("");
//   const handlePageChange = (event, newPage) => {
//     gotoPage(newPage - 1); // Adjust for 0-based index used by react-table
//     setCurrentPage(newPage);
//   };

//   const handleGotoPage = () => {
//     const pageNumber = parseInt(gotoPageInput, 10);
//     if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= pageCount) {
//       gotoPage(pageNumber - 1);
//       setCurrentPage(pageNumber);
//       setGotoPageInput("");
//     }
//   };

//   return (
//     <>
//       <div className="table_scroll">
//         <table {...getTableProps()}>
//           <thead>
//             {headerGroups?.map((headerGroup) => (
//               <tr {...headerGroup.getHeaderGroupProps()}>
//                 {headerGroup?.headers?.map((column) => (
//                   <th {...column.getHeaderProps()}>
//                     <span>
//                       {column.render("Header")}
//                       {column["Header"] !== "" ? (
//                         <img
//                           src={CaretDownGrayIcon}
//                           alt=""
//                         />
//                       ) : (
//                         <></>
//                       )}
//                     </span>
//                   </th>
//                 ))}
//               </tr>
//             ))}
//           </thead>
//           <tbody {...getTableBodyProps()}>
//             {page?.map((row) => {
//               prepareRow(row);
//               return (
//                 <tr {...row?.getRowProps()}>
//                   {row.cells?.map((cell, index) => (
//                     <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
//                   ))}
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>
//       {/* {pageOptions.length > 1 && (
//         <div className="pagination_main">
//           <Pagination
//             count={pageCount}
//             page={currentPage}
//             onChange={handlePageChange}
//             color="primary"
//             boundaryCount={1}
//           />
//         </div>
//       )} */}
//       {pageOptions.length > 1 && (
//         <div className="economiccalender-pagination pagination">
//           <img
//             src={CaretLeftIcon}
//             alt="left-arrow"
//           />
//           <button
//             onClick={() => previousPage()}
//             disabled={!canPreviousPage}
//           >
//             Previous
//           </button>
//           {pageOptions.map((pageNumber, index) => (
//             <>
//               <button
//                 key={index}
//                 onClick={() => gotoPage(index)}
//                 className={pageIndex === index ? "btn-active" : "non-active"}
//               >
//                 {pageNumber < 10 ? `0${pageNumber + 1}` : pageNumber}
//               </button>
//             </>
//           ))}
//           <button
//             onClick={() => nextPage()}
//             disabled={!canNextPage}
//           >
//             Next
//           </button>
//           <img
//             src={CaretRightIcon}
//             alt="right-arrow"
//           />
//           <div className="goto-page-input">
//             <input
//               type="number"
//               placeholder="Go to Page"
//               value={gotoPageInput}
//               onChange={(e) => setGotoPageInput(e.target.value)}
//             />
//             <button
//               className="goToButton"
//               onClick={handleGotoPage}
//             >
//               Go
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }
